// n.b. any changes made here should be mirrored in the Signal.Util.isBagPage function (signal.js)
const isBagPage = path => !!path.match(/^(\/[a-zA-Z]{2})?\/bag(\/$|$)/);

export default isBagPage;



// WEBPACK FOOTER //
// ./template/helpers/isBagPage.js